module.exports = __webpack_public_path__ + "img/map-nove-bloky.9028d39e.jpg";